module.exports = __webpack_public_path__ + "img/zko5.67a79322.jpg";